module.exports = __webpack_public_path__ + "img/shrimps-1.1ce7c9d4.jpg";